import { Route } from '@angular/router';
import { AuthGuardService } from './services/auth-guard.service';

export const appRoutes: Route[] = [
  {
    path: '',
    canActivate: [AuthGuardService],
    pathMatch: 'full',
    loadComponent: () => import('./pages/home/home.component').then(m => m.HomeComponent),
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: 'events',
    canActivate: [AuthGuardService],
    loadComponent: () => import('./pages/events/events.component').then(m => m.EventsComponent),
  },
  {
    path: 'users',
    canActivate: [AuthGuardService],
    loadComponent: () => import('./pages/users/users.component').then(m => m.UsersComponent),
  },
  {
    path: 'lottery',
    canActivate: [AuthGuardService],
    loadComponent: () => import('./pages/lottery/lottery.component').then(m => m.LotteryComponent),
  },
  {
    path: 'balloons/print',
    canActivate: [AuthGuardService],
    loadComponent: () => import('./pages/balloons-print/balloons-print.component').then(m => m.BalloonsPrintComponent),
  },
  {
    path: 'balloons',
    canActivate: [AuthGuardService],
    loadComponent: () => import('./pages/balloons/balloons.component').then(m => m.BalloonsComponent),
  },
];
